// extracted by mini-css-extract-plugin
export default {"buttonStyle":"Button_buttonStyle__g9vbm"};